"use client";
import dynamic from "next/dynamic";

const MobileDrawer = dynamic(
  () => import("react-drag-mobile-drawer").then((mod) => mod.MobileDrawer),
  { ssr: false }
);

export default MobileDrawer;
